export default "__VITE_ASSET__f49ab19a__"